module.exports = "/images/img_landing_icon_mobile_v2.png?0adb72ac6f3002cf6d43d2f7aaf7ccf0";